import { ArrowLeft, ArrowRight, Play } from 'react-feather';
import { Video } from '../../../types/Video';
import VideoPlayer from '../VideoPlayer';
import { useNavigate } from 'react-router-dom';
import { hapticsImpactLight } from '../../../utils/haptics';
import { useEffect, useState } from 'react';
import { fetchArticlePreview } from '../../../services/library';
import parse from 'html-react-parser';
import { Topic } from '../../../types/Dashboard';

interface VideoPageProps {
  video: Video;
  setActiveVideo: (video: Video | null) => void;
  upNextVideos: Video[];
  getThumbnail: () => string;
  videosViewedInSequence: Video[];
  setVideosViewedInSequence: (videos: Video[]) => void;
}

const VideoPage: React.FC<VideoPageProps> = ({
  video,
  setActiveVideo,
  upNextVideos,
  getThumbnail,
  videosViewedInSequence,
  setVideosViewedInSequence,
}) => {
  const navigate = useNavigate();

  const [topicSummary, setTopicSummary] = useState<string>('');

  useEffect(() => {
    if (video.topics) {
      fetchArticleSummary(video.topics);
    }
  }, [video.id]);

  const fetchArticleSummary = async (topics: Topic[]) => {
    const firstTopic = topics[0];
    if (firstTopic.articleId) {
      const data = await fetchArticlePreview(firstTopic.articleId);
      if (data && data.articlePreview) {
        setTopicSummary(data.articlePreview);
      }
    }
  };

  return (
    <div className="video-page">
      <div className="video-page_main">
        <button
          className="button button--link button--back"
          style={{ paddingLeft: '0', paddingTop: '0', marginBottom: '.5rem' }}
          onClick={() => {
            setActiveVideo(null);
            navigate('/videos');
            hapticsImpactLight();
            window.scrollTo(0, 0);
          }}
        >
          <ArrowLeft />
          All Videos
        </button>
        <VideoPlayer
          title={video.title || ''}
          cover={getThumbnail()}
          video={video}
          showSpeedOptions={true}
        />
        <div className="video-page_main_topic-summary">
          <div className="video-page_main_topic-summary_content">
            {parse(topicSummary)}
            <div className="video-page_main_topic-summary_content_footer">
              <button
                className="button button--link"
                onClick={() => {
                  navigate(`/library/${video.topics[0].articleId}`);
                }}
              >
                Read more about this topic
                <ArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>
      {upNextVideos.length > 0 && (
        <div className="video-page_sidebar">
          <h3 className="video-page_sidebar_title">Up Next</h3>
          <div className="video-page_sidebar_videos">
            {upNextVideos.map((video) => (
              <button
                key={video.id}
                className="video-card"
                style={
                  {
                    '--video-thumbnail': `url(${getThumbnail()})`,
                  } as React.CSSProperties
                }
                onClick={() => {
                  setActiveVideo(video);
                  navigate(`/videos/${video.id}`);
                  setVideosViewedInSequence([...videosViewedInSequence, video]);
                  hapticsImpactLight();
                }}
              >
                <div className="play-button">
                  <Play />
                </div>
                <div className="video-info">
                  {video.title && <h3>{video.title}</h3>}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoPage;
